import { nextTick } from 'vue'

export function inRect(x: number, y: number, rect: { left: number, top: number, width: number, height: number }): boolean {
  return x >= rect.left && x <= rect.left + rect.width && y >= rect.top && y <= rect.top + rect.height
}

export function getElementTop(el: any): number {
  let actualTop = el.offsetTop
  let current = el.offsetParent
  while (current !== null) {
    actualTop += current.offsetTop
    current = current.offsetParent
  }
  return actualTop
}

export function scrollToInvalidFirstElement() {
  const isError = document.getElementsByClassName('is-error')
  nextTick().then(() => {
    isError[0].scrollIntoView({
      // 滚动到指定节点
      // 值有start,center,end，nearest，当前显示在视图区域中间
      block: 'start',
      // 值有auto、instant,smooth，缓动动画（当前是慢速的）
      behavior: 'smooth',
    })
  })
}
